import StatefulTabs from './StatefulTabs';

export default StatefulTabs;
